import "./HeroHeader.scss";

export default {
  root: "im-hero-header",
  default: "im-hero-header--default",
  candidate: "im-hero-header--candidate",
  establishment: "im-hero-header--establishment",
  agency: "im-hero-header--agency",
  container: "im-hero-header__container",
  textWrapper: "im-hero-header__text-wrapper",
  typeWrapper: "im-hero-header__type-wrapper",
  typeLabel: "im-hero-header__type-label",
  title: "im-hero-header__title",
  description: "im-hero-header__description",
  illustrationWrapper: "im-hero-header__illustration-wrapper",
  illustration: "im-hero-header__illustration",
  patterns: "im-hero-header__patterns",
  pattern: "im-hero-header__pattern",
  pattern0: "im-hero-header__pattern--0",
  pattern1: "im-hero-header__pattern--1",
  pattern2: "im-hero-header__pattern--2",
  navCardsWrapper: "im-hero-header__nav-cards-wrapper",
  navCards: "im-hero-header__nav-cards",
};
